import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { Button, Stack } from '@mui/material';
import { GapInCreativeWarningBar } from './GapInCreativeWarningBar';
import { AdvancedBox } from '../../../AdvancedBox/AdvancedBox';
import { useManage } from './hooks/useManage';
import { CancelButtonStyled } from '../../../styles';
import { ExclamationIconStyled } from './styles';
import { ManageHeader } from './ManageHeader';
import { ManageTable } from './ManageTable';

export const Manage = ({
  onClose,
  onSubmit,
  isDisplay,
  ...props
}: {
  onClose: () => void;
  onSubmit: () => void;
  isDisplay: boolean;
}) => {
  const { control, disabled, submit, gapsInCreative, removeGapWarningBar } =
    useManage({
      onSubmit,
    });

  return (
    <AdvancedBox
      {...props}
      error={
        gapsInCreative?.length > 0 && (
          <GapInCreativeWarningBar
            onClose={removeGapWarningBar}
            gap={gapsInCreative}
          />
        )
      }
      errorProps={{
        icon: <ExclamationIconStyled icon={faTriangleExclamation} />,
        type: 'warning',
      }}
      onClose={onClose}
      header={<ManageHeader control={control} isDisplay={isDisplay} />}
    >
      <Stack flex={1} gap={7.5}>
        <ManageTable onSubmit={onSubmit} isDisplay={isDisplay} />
        <Stack>
          <Stack direction="row" justifyContent="space-between">
            <Stack>
              <CancelButtonStyled variant="text" onClick={onClose}>
                Cancel
              </CancelButtonStyled>
            </Stack>
            <Button
              data-testid="save-creative-button"
              disabled={disabled}
              onClick={submit}
              variant="contained"
            >
              Save Creative
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </AdvancedBox>
  );
};
